module.exports = __webpack_public_path__ + "img/IMG-20200722-WA0009.10576ad0.jpg";